import * as _bootstrap from 'bootstrap';

import Inputmask from 'inputmask';
// Initialize Inputmask for card validation form
Inputmask('99/99/9999', {
  placeholder: '',
  showMaskOnHover: false,
  showMaskOnFocus: false,
  clearIncomplete: true,
}).mask('[data-inputmask*="99/99/9999"]');
  
$(function() {
  if (window.location.href.indexOf('validate_card') !== -1) {
    const el = document.getElementById('verify-card-modal');
    const modal = _bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }

  $('.js-trigger-set-location').click(function(e) {
    e.preventDefault();
  });
});